import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "Table",
			clipPath: "url(#clip0_4166_14400)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M17.3571 1.92493H0.642857C0.287277 1.92493 0 2.2122 0 2.56778V15.4249C0 15.7805 0.287277 16.0678 0.642857 16.0678H17.3571C17.7127 16.0678 18 15.7805 18 15.4249V2.56778C18 2.2122 17.7127 1.92493 17.3571 1.92493ZM16.5536 6.1035H12.2946V3.37136H16.5536V6.1035ZM16.5536 10.6035H12.2946V7.38921H16.5536V10.6035ZM6.99107 7.38921H11.0089V10.6035H6.99107V7.38921ZM11.0089 6.1035H6.99107V3.37136H11.0089V6.1035ZM1.44643 7.38921H5.70536V10.6035H1.44643V7.38921ZM1.44643 3.37136H5.70536V6.1035H1.44643V3.37136ZM1.44643 11.8892H5.70536V14.6214H1.44643V11.8892ZM6.99107 11.8892H11.0089V14.6214H6.99107V11.8892ZM16.5536 14.6214H12.2946V11.8892H16.5536V14.6214Z",
				fill: "currentColor",
				fillOpacity: .85
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4166_14400",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 18,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTable);
export { ForwardRef as ReactComponent };
